/**
 * URL helpers for the i18n module
 * @module @infra/i18n
 */

import { getI18nService } from './i18n';

/**
 * Appends the current UI language as a `locale` query param. Used for
 * external redirects (e.g. FusionAuth's `/oauth2/authorize`) that render a
 * locale-specific page/theme but have no way to read our app's language
 * state on their own.
 */
export function appendLocaleParam(url: string): string {
  if (!url) return url;
  // The internal code, not the BCP-47 tag: FusionAuth's theme compares the locale by
  // string (`locale == 'en'`) and its message bundles are keyed by these same codes, so
  // sending `vi-VN` would stop matching them. Every code we send is a valid language tag
  // on its own.
  const locale = getI18nService().getLanguage();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}locale=${encodeURIComponent(locale)}`;
}
